import { Component } from "@theme/component";
import { ThemeEvents, FreeShippingMessageUpdateEvent } from '@theme/events';

/* <announcement-bar> — free-shipping message + countdown-timer updates */
class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Handlers are arrow fields (already bound); base Component aborts the
    // signal on disconnect, so no manual removeEventListener is needed.
    const { signal } = this.abortController;
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate, { signal });
    document.addEventListener('countdown:end', this.#handleCountdownEnd, { signal });
  }

  /**
   * Updates free shipping message when cart changes
   */
  #handleCartUpdate = (event) => {
    if (event.target === this) return;
    const newAnnouncementBarHtml = event.detail.data.sections?.[this.sectionId];
    if (!newAnnouncementBarHtml) return;

    // Parse HTML string to DOM
    const fragment = new DOMParser().parseFromString(newAnnouncementBarHtml, 'text/html');
    const freeShippingBar = fragment.querySelector('free-shipping-bar');
    if (!freeShippingBar) return;

    this.dispatchEvent(new FreeShippingMessageUpdateEvent(this.sectionId, { freeShippingBar: freeShippingBar }));
  }

  /**
   * Handles countdown timer end event
   */
  #handleCountdownEnd = (event) => {
    if (event.target === this) return;
    const countdownTimer = event.target.closest('.announcement-countdown-timer');
    if (!countdownTimer) return;
    if (countdownTimer.dataset?.hideBlockTimeEnd !== 'true') return;
    this.#updateCarousel(countdownTimer);
    this.#updateMarquee(countdownTimer);
  }

  /**
   * Removes countdown timer from carousel when it ends
   */
  #updateCarousel = (countdownTimer) => {
    const carousel = this.querySelector('carousel-component');
    const currentSlide = countdownTimer.closest('.swiper-slide');
    if (!currentSlide || !carousel) return;

    currentSlide.remove();

    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    if (swiperWrapper && swiperWrapper.children.length === 0) {
      this.closest('.shopify-section')?.remove();
      return;
    }

    if (carousel?.swiper && typeof carousel.swiper.update === 'function') {
      carousel.swiper.update();
    }
  }

  /**
   * Removes countdown timer from scrolling content when it ends
   */
  #updateMarquee = (countdownTimer) => {
    const marquee = this.querySelector('marquee-component');

    if (marquee && typeof marquee.removeItem === 'function') {
      marquee.removeItem(countdownTimer);
      const hasVisibleContent = Array.from(
        marquee.querySelectorAll('.marquee__repeated-items')
      ).some((item) => item.childElementCount > 0);

      if (!hasVisibleContent) {
        this.closest('.shopify-section')?.remove();
      }
    }
  }

  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error('Section id missing');

    return sectionId;
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
